import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';

@Component({
  selector: 'app-help-centre',
  imports: [MatButtonModule, MatIconModule, MatMenuModule],
  templateUrl: './help-centre.component.html',
  styleUrl: './help-centre.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HelpCentreComponent {
  links = [
    {
      url: 'https://ada-apps-akersolutions.atlassian.net/wiki/external/ZDE4NmFmYzMxZGQyNGY3MDlmNzQzNzJhY2Q4ZGIzMWI',
      title: 'Read the Product Guide',
      description: 'Step by step guides on how to use Information Exchange',
      icon: 'report',
    },
    {
      url: 'https://esupport.akersolutions.com/Ada',
      title: 'Contact Support',
      description: 'Raise a ticket with our support team',
      icon: 'group',
    },
    {
      url: 'https://ada-apps-akersolutions.atlassian.net/wiki/external/NGVkNzYzYjQzZTgwNDZjOTljZDk0NjQ1ODUxNzRjYTc',
      title: 'Release Notes',
      description: 'View the Information Exchange Release Notes',
      icon: 'bullhorn',
    },
  ];
}
